import { LandingActionCreators } from 'actions/landing';
import { LandingState } from 'models/landing';

export const initialState: LandingState = {
  isLoading: false
};

type Action = typeof LandingActionCreators[keyof typeof LandingActionCreators];

export function landingReducer(state = initialState, action: Action): typeof initialState {
  switch (action.type) {
    case LandingActionCreators.setIsOnRequest.type:
      return { ...state, isLoading: true };
    case LandingActionCreators.setIsReceived.type:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/landing.ts